import { gql } from '@apollo/client'

export const GET_ZONE_HIERARCHY = gql`
  query GetZoneHierarchy {
    zoneHierarchy {
      zones {
        id
        parentId
        name
        tier
        assignedUsers {
          fullName
          mainRole
        }
        manager {
          fullName
        }
      }
    }
  }
`
